;(function () {
  'use strict'

  angular.module('contrast.attacks').controller('AttacksCtrl', AttacksCtrl)

  function AttacksCtrl(
    $scope,
    $rootScope,
    $routeParams,
    $routeSegment,
    $location,
    $timeout,
    $uibModal,
    $filter,
    $translate,
    logger,
    permissions,
    dialogs,
    csTemplates,
    ErrorService,
    AttackService,
    AttackSearchService,
    UserService,
    LoadFilterService,
    TimeService,
    AdvancedFiltersService,
    PromiseService,
    AttackFactory,
    IPBlacklistModalService,
    ATTACK_STATUS,
    SUBFILTERS,
    ATTACK_SORTS,
    UNKNOWN_SOURCE_KEY,
    onboardingTutorialConstants
  ) {
    'ngInject'

    // Minimum attack amount to avoid sending footer to bottom
    var minAttacksForNormalFooter = 10

    var translGlobal = {
      title_startDate: $translate.instant('title_startDate'),
      title_endDate: $translate.instant('title_endDate')
    }

    var _searchKeywords = '',
      subfilterIds = SUBFILTERS.ATTACKS.LIST,
      selectedSubFilters =
        AdvancedFiltersService.generateSelectedConfig(subfilterIds),
      requestMapping = SUBFILTERS.ATTACKS.REQUEST_MAPPING,
      lastSubfilterSearches = {},
      lastSearch = {},
      lastUUIDSearch = {},
      timeDiff = TimeService.getOffsetDifference(),
      momentFormat = TimeService.getDateTimeFormat(),
      suppressSingleAttackUrl = 'views/attacks/suppress_single.tpl.html',
      suppressSingleUnknownAttackUrl =
        'views/attacks/suppress_single_unknown.tpl.html',
      suppressMultipleAttackUrl = 'views/attacks/suppress_multiple.tpl.html',
      openOnLoad = angular.isDefined($routeParams.attackId)

    function init() {
      setSubgridFilters()
      if (isSubgrid()) {
        $scope.selectedQuickFilter = {
          name: 'All',
          filterType: 'ALL',
          count: '?'
        }
        $scope.model.date = {}
      }

      if (
        LoadFilterService.getAttackApplications() ||
        LoadFilterService.getAttackServers() ||
        LoadFilterService.getAttackSeverities() ||
        LoadFilterService.getAttackEventAttackers() ||
        LoadFilterService.getAttacksLive() ||
        LoadFilterService.getAttacksDate() ||
        LoadFilterService.getAttackEnvironment() ||
        LoadFilterService.getNoProbed() ||
        LoadFilterService.getAttackStatus() ||
        LoadFilterService.getAttackType() ||
        LoadFilterService.getAttackQuickFilter()
      ) {
        if (LoadFilterService.getAttackBB()) {
          LoadFilterService.setAttackBB(false)
          $scope.model.includeBotBlockers = true
        }

        if (LoadFilterService.getAttackIP()) {
          LoadFilterService.setAttackIP(false)
          $scope.model.includeIpBlacklist = true
        }

        if (LoadFilterService.getAttackStatus()) {
          selectedSubFilters.status = [LoadFilterService.getAttackStatus()]
          LoadFilterService.setAttackStatus(false)
        }

        if (LoadFilterService.getAttackEnvironment()) {
          selectedSubFilters.server_environments = [
            LoadFilterService.getAttackEnvironment()
          ]
          LoadFilterService.setAttackEnvironment(false)
        }

        if (LoadFilterService.getAttacksLive()) {
          LoadFilterService.setAttacksLive(false)
          $scope.selectedQuickFilter.filterType = 'ACTIVE'
        } else if (LoadFilterService.getAttackType()) {
          $scope.selectedQuickFilter.filterType =
            LoadFilterService.getAttackType()
          LoadFilterService.setAttackType(false)
        } else if (LoadFilterService.getAttacksDate()) {
          $scope.model.date = LoadFilterService.getAttacksDate()
          LoadFilterService.setAttacksDate(false)
        }

        if (LoadFilterService.getAttackQuickFilter()) {
          $scope.selectedQuickFilter.filterType =
            LoadFilterService.getAttackQuickFilter()
          LoadFilterService.setAttackQuickFilter(false)
        }

        loadFilters(true)
      } else {
        loadFilters(false, true)
        $scope.attacksPromise = loadAttacks($scope.numPerLoad, 0)
        getQuickFilters()
      }

      $scope.$on('$destroy', _destroy)
    }

    function _destroy() {
      $rootScope.$broadcast('changeFooterBottom', { shouldSendToBottom: false })
    }

    angular.extend($scope, AdvancedFiltersService.getSubfilterLimitConfig())

    angular.extend($scope, {
      attacks: [],
      count: 0,
      numPerLoad: 15,

      row: '-startTime',
      searchKeywords: searchKeywords,

      tutorial: UserService.createOnboardingTutorialItem(
        onboardingTutorialConstants.TUTORIAL_TYPE.ATTACKS
      ),

      model: {
        selectedAttacks: [],
        selectAll: false,
        includeSuppressed: false,
        includeBotBlockers: false,
        includeIpBlacklist: false,
        date: {
          startDate: moment().subtract(1, 'days').add(timeDiff, 'm'), // needed to parse the local time to the "user settings" time zone
          endDate: moment().startOf('minute').add(timeDiff, 'm') // needed to parse the local time to the "user settings" time zone
        },
        keyword: '',
        busy: true,
        attack_status: ATTACK_STATUS
      },

      quickFilters: [],
      selectedQuickFilter: {
        name: 'Effective',
        filterType: 'EFFECTIVE',
        count: '?'
      },

      tagsfilters: {},
      filtersVisible: false,

      discussionCount: {
        total: 0,
        unread: false
      },
      datePickerExtraOpts: [
        { value: 'START', label: translGlobal.title_startDate, default: true },
        { value: 'END', label: translGlobal.title_endDate }
      ],
      appId: $routeParams.appId
    })

    angular.extend($scope, {
      deleteDate: deleteDate,
      loadAttacksByFilterChange: subFilterSelectCallback,
      loadAttacksByScroll: loadAttacksByScroll,
      order: order,
      suppress: suppress,
      exportXMLSingle: exportXMLSingle,
      exportCSVSingle: exportCSVSingle,
      showAllAttacks: showAllAttacks,
      checkPermission: checkPermission,

      quickFilterSelect: quickFilterSelect,
      toggleFilters: toggleFilters,
      clearFilters: clearFilters,
      filtersSet: filtersSet,
      selectSubfilter: AdvancedFiltersService.selectSubfilter(
        selectedSubFilters,
        subFilterSelectCallback
      ),
      getFiltersSelected: getFiltersSelected,
      reloadFilters: subFilterSelectCallback,

      onSelectAll: onSelectAll,
      onSelect: onSelect,
      overview: overview,

      markAllMessagesAsRead: markAllMessagesAsRead,
      tag: tag,

      blacklist: blacklist,
      isSubgrid,
      isDefendEnabled,
      hideSubgridFilter,
      isOnlySubgridFilterSet
    })

    function setSubgridFilters() {
      if (
        $routeSegment.name === 'serverDashboard.attacks' &&
        $routeParams.serverId
      ) {
        selectedSubFilters.servers = [$routeParams.serverId]
      }

      if ($routeSegment.name === 'appDashboard.attacks' && $routeParams.appId) {
        selectedSubFilters.applications = [$routeParams.appId]
      }
    }

    function hideSubgridFilter(filterId) {
      if (
        $routeSegment.name === 'appDashboard.attacks' &&
        filterId === 'applications'
      ) {
        return true
      }

      if (
        $routeSegment.name === 'serverDashboard.attacks' &&
        filterId === 'servers'
      ) {
        return true
      }

      return false
    }

    function isSubgrid() {
      return (
        $routeSegment.name === 'serverDashboard.attacks' ||
        $routeSegment.name === 'appDashboard.attacks'
      )
    }

    function isDefendEnabled() {
      return (
        ($routeSegment.name === 'serverDashboard.attacks' &&
          $scope.server &&
          $scope.server.defend) ||
        ($routeSegment.name === 'appDashboard.attacks' &&
          $scope.application &&
          $scope.application.defend)
      )
    }

    function isOnlySubgridFilterSet() {
      if (isSubgrid()) {
        const targetFilter =
          $routeSegment.name === 'serverDashboard.attacks'
            ? 'servers'
            : 'applications'
        // eslint-disable-next-line prefer-const
        for (let subfilterId of subfilterIds) {
          if (
            subfilterId !== targetFilter &&
            selectedSubFilters[subfilterId].length > 0
          ) {
            return false
          }
        }
        return true
      }
      return false
    }

    function searchKeywords(newSearchKeywords) {
      if (!arguments.length) {
        return _searchKeywords
      }

      if (newSearchKeywords !== _searchKeywords) {
        _searchKeywords = newSearchKeywords
      }

      loadAttacksByFilterChange()
      loadSubfilters()

      return _searchKeywords
    }

    function subFilterSelectCallback() {
      loadAttacksByFilterChange()
      loadSubfilters()
    }

    function getFiltersSelected(id) {
      if (id) {
        return AdvancedFiltersService.buildSelectedMessage(
          selectedSubFilters[id]
        )
      }
      return ''
    }

    function tag(selectedAttacks) {
      var transl = {
        title_attacks_tagAttacks: $translate.instant('title_attacks_tagAttacks')
      }

      $uibModal
        .open({
          templateUrl: 'views/tags/modal_tag.html',
          controller: 'ModalTagAttacksCtrl',
          size: 'sm',
          resolve: {
            attacks: function () {
              return selectedAttacks
            },
            title: function () {
              return transl.title_attacks_tagAttacks
            }
          }
        })
        .result.then(function () {
          $scope.attacks = []
          $scope.model.selectedAttacks = []
          $scope.model.selectAll = false
          clearFilters()
        })
    }

    function blacklist(attack) {
      IPBlacklistModalService.openCreate(attack)
    }

    function markAllMessagesAsRead() {
      AttackFactory.updateLastViewed($routeParams.attackId).then(function () {
        $scope.model.discussionCount.unread = false
      }, ErrorService.processError)
    }

    function overview(index, attackUuid) {
      AttackSearchService.setIndex(index)
      $location.path(
        UserService.buildUrl('/attacks/' + attackUuid + '/overview')
      )
    }

    function filtersSet() {
      var i = 0

      for (; i < subfilterIds.length; i++) {
        if (selectedSubFilters[subfilterIds[i]].length > 0) {
          return true
        }
      }
      return false
    }

    function toggleFilters() {
      $scope.filtersVisible = !$scope.filtersVisible
      if (!$scope.subFiltersLoaded) {
        loadSubfilters().then(function () {
          $scope.subFiltersLoaded = true
        })
      }
    }

    function clearFilters() {
      var i = 0
      for (; i < subfilterIds.length; i++) {
        selectedSubFilters[subfilterIds[i]] = []
      }

      $scope.model.includeSuppressed = false
      $scope.model.includeBotBlockers = false
      $scope.model.includeIpBlacklist = false

      $scope.attacks = []

      setSubgridFilters()

      loadFilters()
      $scope.attacksPromise = loadAttacks($scope.numPerLoad, 0)
      getQuickFilters()
    }

    function loadFilters(loadFiltersSet, skipLoadSubFilters) {
      return AttackFactory.getFiltersCatalogs().then(function (response) {
        $scope.tagsfilters.filters = angular.copy(response.data.catalogs)

        if (!skipLoadSubFilters) {
          loadSubfilters().then(function () {
            if (loadFiltersSet) {
              loadAttacks($scope.numPerLoad, 0)
              getQuickFilters()
            }
          })
        }
      }, ErrorService.processError)
    }

    function loadSubfilters() {
      return AdvancedFiltersService.loadSubfilters(
        $scope.tagsfilters.filters,
        lastSubfilterSearches,
        getFiltersRequest(true),
        AdvancedFiltersService.transformSelectedSubfilters(
          selectedSubFilters,
          requestMapping
        ),
        getSubfilterRequest,
        checkSubfiltersAfterLoad,
        subfiltersSort
      ).then(clearLoadFilters)
    }

    function getSubfilterRequest(filterId, searchFilters) {
      return AttackFactory.getFiltersByType(filterId, searchFilters)
    }

    function checkSubfiltersAfterLoad(filter, subFilter) {
      var shouldSelect = false
      switch (filter.id) {
        case SUBFILTERS.ATTACKS.ENUM.APPLICATIONS:
          var apps = LoadFilterService.getAttackApplications()
          if (
            apps &&
            (apps === subFilter.keycode || apps.indexOf(subFilter.keycode) > -1)
          ) {
            shouldSelect = true
          }
          break

        case SUBFILTERS.ATTACKS.ENUM.SERVERS:
          if (LoadFilterService.getAttackServers() === subFilter.keycode) {
            shouldSelect = true
          }
          break

        case SUBFILTERS.ATTACKS.ENUM.RULES:
          var rules = LoadFilterService.getAttackEventRules()
          if (
            rules &&
            (rules.indexOf(subFilter.keycode) > -1 ||
              rules.indexOf(subFilter.label) > -1)
          ) {
            shouldSelect = true
          }
          break

        case SUBFILTERS.ATTACKS.ENUM.SEVERITIES:
          var severities = LoadFilterService.getAttackSeverities()
          if (severities && severities.indexOf(subFilter.keycode) > -1) {
            shouldSelect = true
          }
          break

        case SUBFILTERS.ATTACKS.ENUM.ATTACKERS:
          if (subFilter.keycode === UNKNOWN_SOURCE_KEY) {
            subFilter.translatedLabel = 'detail_attacks_unknown_source'
          }
          var attackers = LoadFilterService.getAttackEventAttackers()
          if (attackers && attackers.indexOf(subFilter.keycode) > -1) {
            shouldSelect = true
          }
          break

        case SUBFILTERS.ATTACKS.ENUM.STATUS:
          var statuses = LoadFilterService.getAttackStatus()
          if (
            LoadFilterService.getNoProbed() &&
            subFilter.keycode !== ATTACK_STATUS.PROBED.value
          ) {
            shouldSelect = true
          } else if (
            LoadFilterService.getAttackStatus() &&
            statuses.indexOf(subFilter.keycode) > -1
          ) {
            shouldSelect = true
          }
          break

        case SUBFILTERS.ATTACKS.ENUM.TAGS:
          var tags = LoadFilterService.getAttackTags()
          if (tags && tags.indexOf(subFilter.keycode) > -1) {
            shouldSelect = true
          }
          break

        case SUBFILTERS.ATTACKS.ENUM.SERVER_ENVIRONMENT:
          if (LoadFilterService.getAttackEnvironment() === subFilter.keycode) {
            shouldSelect = true
          }
          break

        default:
          break
      }

      if (shouldSelect) {
        subFilter.checked = true
        filter.opened = true
        $scope.selectSubfilter(subFilter, filter)
      }
    }

    function subfiltersSort(subFilters, filterId) {
      switch (filterId) {
        case SUBFILTERS.ATTACKS.ENUM.APPLICATION_IMPORTANCE:
          return $filter('orderBy')(subFilters, function (item) {
            return ATTACK_SORTS.APP_IMPORTANCE.indexOf(item.keycode)
          })

        case SUBFILTERS.ATTACKS.ENUM.SERVER_ENVIRONMENT:
          return $filter('orderBy')(subFilters, function (item) {
            return ATTACK_SORTS.SERVER_ENVIRONMENT.indexOf(item.keycode)
          })

        case SUBFILTERS.ATTACKS.ENUM.SEVERITIES:
          return $filter('orderBy')(subFilters, function (item) {
            return ATTACK_SORTS.SEVERITY.indexOf(item.keycode)
          })

        case SUBFILTERS.ATTACKS.ENUM.STATUS:
          return $filter('orderBy')(subFilters, function (item) {
            return ATTACK_SORTS.STATUS.indexOf(item.keycode)
          })

        default:
          break
      }
      return AdvancedFiltersService.defaultSubfilterSortFn(subFilters)
    }

    function clearLoadFilters() {
      LoadFilterService.setAttackApplications(false)
      LoadFilterService.setAttackServers(false)
      LoadFilterService.setAttackEventRules(false)
      LoadFilterService.setAttackSeverities(false)
      LoadFilterService.setAttackEventAttackers(false)
      LoadFilterService.setNoProbed(false)
      LoadFilterService.setAttackTags(false)
      LoadFilterService.setAttackEnvironment(false)
      LoadFilterService.setAttackStatus(false)
      LoadFilterService.setAttackQuickFilter(false)
    }

    function getQuickFilters() {
      $scope.quickFiltersPromise = AttackFactory.getAttackQuickFilters(
        getFiltersRequest()
      ).then(function (response) {
        $scope.quickFilters = response.data.filters
        $scope.selectedQuickFilter = $scope.quickFilters.find(function (
          filter
        ) {
          return filter.filterType === $scope.selectedQuickFilter.filterType
        })
      }, ErrorService.processError)

      return $scope.quickFiltersPromise
    }

    function quickFilterSelect(filter) {
      $scope.selectedQuickFilter = filter
      loadAttacksByFilterChange(false)
      loadSubfilters()
    }

    function checkPermission(permission) {
      return permissions.hasEnterprisePermission(permission)
    }

    function showAllAttacks(attack) {
      attack.rulesLimit = 'Infinity'
    }

    function loadAttacks(limit, offset) {
      if (lastSearch) {
        PromiseService.cancelPromise(lastSearch)
      }

      var filters = {}

      angular.extend(filters, {
        params: {
          sort: $scope.row,
          limit: limit,
          offset: offset
        }
      })

      angular.extend(filters, { data: getFiltersRequest() })

      $scope.model.busy = true

      lastSearch = AttackFactory.getAttacks(filters)

      return lastSearch.then(function (response) {
        var resultAttacks = AttackService.calculateApps(response.data.attacks)

        $scope.attacks = $scope.attacks.concat(resultAttacks)

        $scope.count = response.data.count

        _loadAttacksUUIDs(filters)

        _.each($scope.attacks, function (attack) {
          _.extend(attack, { rulesLimit: 3 })
          _.extend(attack, { appsLimit: 3 })
        })

        if ($scope.attacks.length > 0 && openOnLoad) {
          openOnLoad = false
        }

        if ($scope.attacks.length < minAttacksForNormalFooter) {
          $rootScope.$broadcast('changeFooterBottom', {
            shouldSendToBottom: true
          })
        } else {
          $rootScope.$broadcast('changeFooterBottom', {
            shouldSendToBottom: false
          })
        }

        $timeout(function () {
          $scope.$emit('triggerScrollCheck')
        })

        $scope.model.busy = false
      }, ErrorService.processError)
    }

    function getFiltersRequest(excludeAdvanced) {
      var filters = {
        quickFilter: $scope.selectedQuickFilter.filterType,
        keyword: $scope.searchKeywords(),
        includeSuppressed: $scope.model.includeSuppressed,
        includeBotBlockers: $scope.model.includeBotBlockers,
        includeIpBlacklist: $scope.model.includeIpBlacklist
      }

      if (moment($scope.model.date.startDate, momentFormat).isValid()) {
        filters.startDate = TimeService.getTimeInUserTimeZone(
          moment($scope.model.date.startDate, momentFormat).format('x')
        )
      }

      if (moment($scope.model.date.endDate, momentFormat).isValid()) {
        filters.endDate = TimeService.getTimeInUserTimeZone(
          moment($scope.model.date.endDate, momentFormat).format('x')
        )
      }

      if ($scope.model.date.extraOptionsSelected) {
        filters.dateFilterType = $scope.model.date.extraOptionsSelected
      }

      if (!excludeAdvanced) {
        angular.extend(
          filters,
          AdvancedFiltersService.transformSelectedSubfilters(
            selectedSubFilters,
            requestMapping
          )
        )
      }

      return filters
    }

    function deleteDate() {
      if (
        $scope.model.date.startDate !== null ||
        $scope.model.date.endDate !== null
      ) {
        $scope.model.date = { startDate: null, endDate: null }
        loadAttacksByFilterChange()
        loadSubfilters()
      }
    }

    function loadAttacksByFilterChange(reloadQuickFilters) {
      $scope.attacks = []
      $scope.model.selectedAttacks = []
      $scope.model.selectAll = false

      if (angular.isUndefined(reloadQuickFilters) || reloadQuickFilters) {
        getQuickFilters()
      }

      $scope.attacksPromise = loadAttacks($scope.numPerLoad, 0)
    }

    function loadAttacksByScroll() {
      if ($scope.attacks.length === $scope.count || $scope.model.busy) {
        return
      }

      $scope.scrollPromise = loadAttacks(
        $scope.numPerLoad,
        $scope.attacks.length
      )

      return $scope.scrollPromise
    }

    function order(rowName) {
      if ($scope.row === rowName) {
        return
      }
      $scope.row = rowName
      $scope.loadAttacksByFilterChange()
    }

    function exportXMLSingle(attackId) {
      var attackObj = [
        {
          name: 'attacks',
          value: attackId
        }
      ]

      var data = {
        redirectUrl: UserService.buildAPIUrl('/attacks') + '/export/xml',
        redirectMethod: 'POST',
        redirectData: attackObj
      }

      $rootScope.$broadcast('attack.export', data)
    }

    function exportCSVSingle(attackId) {
      var attackObj = [
        {
          name: 'attacks',
          value: attackId
        }
      ]

      var data = {
        redirectUrl: UserService.buildAPIUrl('/attacks') + '/export/csv',
        redirectMethod: 'POST',
        redirectData: attackObj
      }

      $rootScope.$broadcast('attack.export', data)
    }

    function suppress(attacks) {
      $scope.attacksDetails = attacks

      return csTemplates
        .loadAndInterpolate(
          attacks.length > 1
            ? suppressMultipleAttackUrl
            : $scope.attacksDetails[0].source === null
            ? suppressSingleUnknownAttackUrl
            : suppressSingleAttackUrl,
          {
            attackDetailsSource: $scope.attacksDetails[0].source,
            attackDetailsSize: $scope.attacksDetails.length
          }
        )
        .then(function (interpolatedStr) {
          _launchSuppressDialog(attacks, interpolatedStr)
        })
    }

    function _launchSuppressDialog(attacks, msg) {
      var transl = {
        title_attacks_suppressAttack: $translate.instant(
          'title_attacks_suppressAttack'
        ),
        action_attacks_suppress_attack: $translate.instant(
          'action_attacks_suppress_attack'
        ),
        action_cancel: $translate.instant('action_cancel')
      }

      return dialogs
        .confirm(transl.title_attacks_suppressAttack, msg, {
          size: 'sm',
          yes: transl.action_attacks_suppress_attack,
          no: transl.action_cancel
        })
        .result.then(function () {
          _processSuppressResults(AttackFactory.suppressBatch(attacks))
        })
    }

    function _processSuppressResults(promise) {
      promise.then(function (results) {
        var transl = {
          detail_attacks_noAttacksSuppressed: $translate.instant(
            'detail_attacks_noAttacksSuppressed'
          )
        }

        var count = results.reduce(function (count, result) {
          return count + (result.success ? 1 : 0)
        }, 0)

        if (count === 0) {
          logger.logError(transl.detail_attacks_noAttacksSuppressed)
        } else {
          logger.logSuccess(
            $translate.instant(
              'plural_attacks_attacksSuppressedSuccessfully',
              { count: count },
              'messageformat'
            )
          )
        }

        loadAttacksByFilterChange()
        loadSubfilters()
      })
    }

    function onSelectAll() {
      if ($scope.model.selectAll) {
        _selectAll()
      } else {
        _deselectAll()
      }
    }

    function onSelect(attack) {
      var idx = $scope.model.selectedAttacks.indexOf(attack)

      if (idx > -1) {
        $scope.model.selectedAttacks.splice(idx, 1)
      } else {
        $scope.model.selectedAttacks.push(attack)
      }
      if ($scope.model.selectedAttacks.length !== $scope.attacks.length) {
        $scope.model.selectAll = false
      }

      return $scope.model.selectedAttacks
    }

    function _selectAll() {
      $scope.model.selectedAttacks = []
      angular.forEach($scope.attacks, function (attack) {
        if (!attack.suppressed) {
          attack.selected = true
          $scope.model.selectedAttacks.push(angular.copy(attack))
        }
      })

      return $scope.model.selectedAttacks
    }

    function _deselectAll() {
      $scope.model.selectedAttacks = []
      angular.forEach($scope.attacks, function (attack) {
        attack.selected = false
      })
      return $scope.model.selectedAttacks
    }

    function _loadAttacksUUIDs(requestParams) {
      if (lastUUIDSearch) {
        PromiseService.cancelPromise(lastUUIDSearch)
      }

      lastUUIDSearch = AttackService.getUUIDLoadRequest(
        requestParams,
        $scope.model.entityId
      )
      return lastUUIDSearch.then(function (response) {
        AttackSearchService.setUUIDs(response.data.attacks)
      })
    }

    init()
  }
})()
